module.exports = __webpack_public_path__ + "084b77413e9279a0ecc9ab5d12c715ce.svg";